import { notifyOnError } from '~/rage/decorators';
import { IObservable, Subject } from '~/rage/utils';
import { GameConfigService } from '../GameConfigService';
import { RpcService } from '../RpcService';
import { IJobFarmerService } from './jobFarmerServiceTypes';

export class JobFarmerService implements IJobFarmerService {
	private readonly DEFAULT_GAME_TIME_MS = 30 * 1000;

	private gameTime = new Subject<number>(this.DEFAULT_GAME_TIME_MS);

	constructor(
		private readonly rpc: RpcService,
		private readonly gameConfig: GameConfigService,
	) {
		this.gameConfig.getConfigs().subscribe((configs) => {
			if (!configs) {
				return;
			}

			const minigameTimeMs =
				configs.jobFarmer?.minigameApplesMs ?? this.DEFAULT_GAME_TIME_MS;

			this.gameTime.next(minigameTimeMs);
		});
	}

	public getGameTime(): IObservable<number> {
		return this.gameTime;
	}

	@notifyOnError
	public async reportWin(): Promise<void> {
		await this.rpc.invokeServer('jobs:farmer:reportWin');
	}

	@notifyOnError
	public async reportLoss(): Promise<void> {
		await this.rpc.invokeServer('jobs:farmer:reportLoss');
	}
}
